<div class="filter-section-margin">
	<h4 class="filter-title">Add Filter</h4>
	<acc-main-list-param *ngFor="let f of filters; let i = index" [filter]="f" (onRemoveFilter)="removeFilter(i)" #filterDetails></acc-main-list-param>
    <button mat-mini-fab  type="button" class="add-button" (click)="addFilter()">
        <mat-icon>add</mat-icon>
    </button>
</div>